<template>
<div class="chapter">
<div class="inner_page">
<div class="part1" id="part1">
<div class="chapterHead">
<h2 class="chapterTitle"><img alt="Image" src="images/part.jpg"/><em class="italic">PART 1—</em></h2>
<h2 class="chapterTitle-A"><em class="italic">BANG, I’M NOT DEAD</em></h2>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OnceAMarine_part1.vue?634497ce